import {PipelineStepStatusCode} from 'graphql-client/__generated/graphqlGlobalTypes';

/**
 * An analysis's status, computed from its steps' statuses with the same rules as the server's
 * `compute_pipeline_status_from_step_statuses`. The server stores this aggregate a few seconds after its
 * steps change, so reading it from the steps keeps the status current while the analysis runs.
 */
export default function getAnalysisStatusFromSteps(
  steps: ReadonlyArray<{statusCode: PipelineStepStatusCode}>
): PipelineStepStatusCode {
  const statusCodes = new Set(steps.map(({statusCode}) => statusCode));
  if (statusCodes.has(PipelineStepStatusCode.RUNNING)) {
    return PipelineStepStatusCode.RUNNING;
  }
  if (statusCodes.has(PipelineStepStatusCode.FAILED)) {
    return PipelineStepStatusCode.FAILED;
  }
  if (
    statusCodes.has(PipelineStepStatusCode.WAITING) ||
    statusCodes.has(PipelineStepStatusCode.AI_PROPOSED)
  ) {
    return PipelineStepStatusCode.WAITING;
  }
  if (statusCodes.has(PipelineStepStatusCode.BLOCKED)) {
    return PipelineStepStatusCode.BLOCKED;
  }
  // Halted steps, and steps that succeeded with errors, count as succeeded
  return PipelineStepStatusCode.SUCCEEDED;
}
